import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { usePWA } from '../contexts/PWAContext';
import { useI18n } from '../contexts/I18nContext';

const InstallBanner = () => {
  const { showBanner, isIOS, deferredPrompt, handleInstall, dismissBanner } = usePWA();
  const { t } = useI18n();

  const handleAction = () => {
    if (deferredPrompt) {
      handleInstall();
    } else {
      // For iOS or fallback, don't dismiss — user needs to follow instructions
      // Just hide banner (they can use Settings > Install App for full instructions)
      dismissBanner();
    }
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', damping: 24, stiffness: 280 }}
          className="fixed left-0 right-0 w-full max-w-md mx-auto px-3"
          style={{ bottom: '88px', zIndex: 9999 }}
          data-testid="install-banner"
        >
          <div className="bg-white border border-slate-100 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] flex items-center gap-3 p-3">
            {/* App icon */}
            <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0">
              <img src="/icons/icon-192.png" alt="iRemindit" className="w-full h-full object-cover" />
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-900 leading-tight">
                {t('install.banner_text')}
              </p>
              <p className="text-xs text-slate-400 mt-0.5">
                {isIOS ? t('settings.install_ios_step1') : t('install.banner_sub')}
              </p>
            </div>

            {/* Install button */}
            <button
              onClick={handleAction}
              data-testid="install-banner-btn"
              className="flex-shrink-0 px-3.5 py-1.5 bg-indigo-600 text-white rounded-xl text-xs font-bold active:scale-[0.97] transition-transform"
            >
              {t('install.banner_btn')}
            </button>

            {/* Dismiss */}
            <button
              onClick={dismissBanner}
              data-testid="install-banner-dismiss"
              className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-slate-400"
            >
              <X size={14} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InstallBanner;
